import { render } from "./PricingView.vue?vue&type=template&id=0d87d828&scoped=true"
import script from "./PricingView.vue?vue&type=script&lang=js"
export * from "./PricingView.vue?vue&type=script&lang=js"

import "./PricingView.vue?vue&type=style&index=0&id=0d87d828&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d87d828"]])

export default __exports__